import { BCMSRecord, DisabledPrompt, Link, useBCMSContext, useParams } from "@bcm-dev/bcms-vite";
import { FormContainer, FormRowView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { UIButton } from "components/ui";
import Classes, { UserAccount } from "model";
import { SVGAsset } from "res";

export default function ManageRecipientContent(props) {
    const context = useBCMSContext();
    const { id } = useParams();
    
    BCMSRecord.globalControllerFor(Classes, context);

    const account = UserAccount.initByID(id);

    return (
        <div className="manage-recipient-content back-link-padding">
            <Link to="/advancedAlerts/manageRecipients" className="back-link">
                <span><SVGAsset id="LeftChevronIcon" /> Back</span>
            </Link>

            <p className="page-subtitle">Manage Recipient</p>

            <FormContainer className="small-form-width">
                <FormRowView>
                    <p>Recipient { account.emailAddress }</p>
                </FormRowView>

                <FormButtonRow>
                    <DisabledPrompt>
                        <UIButton className="primary-button disabled" text="Active" />
                        <UIButton className="primary-button" text="Delete" />
                    </DisabledPrompt>
                </FormButtonRow>
            </FormContainer>
        </div>
    );
}